// extracted by mini-css-extract-plugin
export default {"accordionDetailsTint":"AllEventsTab_accordionDetailsTint__I7u30"};